import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  size?: 'lg' | 'xl';
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  size = 'lg',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold text-white bg-orange-500 hover:bg-orange-600 rounded-lg transition-all duration-200 shadow-[0_4px_14px_0_rgba(249,115,22,0.39)] hover:shadow-[0_6px_20px_rgba(249,115,22,0.23)] hover:-translate-y-0.5 active:translate-y-0 active:shadow-none';
  const sizes = {
    lg: 'text-lg py-4 px-8',
    xl: 'text-xl py-5 px-10'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${sizes[size]} ${widthClass} ${className}`} {...props} data-id="element-105">
      {children}
    </button>;
}